import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {ActionablePopupProps} from '@Components/actionable-popup/actionable-popup.types';
import type {ActionablePopupPanelProps} from '@Panels/actionable-popup-panel/actionable-popup-panel.types';

export const openActionablePopupModal = ({body, image, ctaButton, closeButtonPosition, onClose}: ActionablePopupProps): void => {
  let hasClaimedInteraction = false;
  let hasOpened = false;

  const panelProps: ActionablePopupPanelProps = {
    body,
    image,
    closeButtonPosition,
    ctaButton: {
      ...ctaButton,
      onClick: (): void => {
        hasClaimedInteraction = true;
        ctaButton.onClick();
      },
    },
  };

  const unsubscribe = window.PMW.redux.store.subscribe((): void => {
    const isOpen = window.PMW.redux.store.getState().modals.modalsHashmap[MODALS_IDS.ACTIONABLE_POPUP_MODAL]?.isOpen;
    if (!hasOpened) {
      hasOpened = isOpen;
      return;
    }
    if (!isOpen) {
      unsubscribe();
      if (!hasClaimedInteraction) {
        onClose();
      }
    }
  });

  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.ACTIONABLE_POPUP_MODAL,
      panelProps,
    })
  );
};
